import { render, staticRenderFns } from "./Buzon.vue?vue&type=template&id=06fe3a31&scoped=true&"
import script from "./Buzon.vue?vue&type=script&lang=js&"
export * from "./Buzon.vue?vue&type=script&lang=js&"
import style0 from "./Buzon.vue?vue&type=style&index=0&id=06fe3a31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fe3a31",
  null
  
)

export default component.exports